import { Link } from "react-router-dom";

const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/b33c731a0a8a80a76070c43759aaf839.png"
                  alt="Dr. Erick Tejada"
                  className="w-10 h-10 object-contain brightness-200"
                />
              </div>
              <div>
                <p className="font-semibold text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  Dr. Erick Tejada
                </p>
                <p className="text-xs text-teal-400" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  Colposcopia &amp; Ginecología
                </p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Especialistas en detección temprana del VPH y colposcopia en Ciudad de Panamá. Tu salud femenina es nuestra prioridad.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/drericktejada/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-teal-600 transition-colors cursor-pointer"
                aria-label="Instagram Dr. Erick Tejada"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-green-600 transition-colors cursor-pointer"
                aria-label="WhatsApp Dr. Erick Tejada"
              >
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-300 mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              <a href="/servicios">Servicios</a>
            </h4>
            <ul className="space-y-2.5">
              {["Colposcopia Digital", "Papanicolaou (Pap)", "Tipificación Viral / Genotipificación", "Cirugía Ambulatoria", "Ginecología General"].map((s) => (
                <li key={s}>
                  <Link
                    to="/servicios"
                    className="text-slate-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-300 mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Información
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Inicio", path: "/" },
                { label: "Servicios", path: "/servicios" },
                { label: "Sobre el Doctor", path: "/sobre-el-doctor" },
              ].map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-slate-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-300 mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Contacto
            </h4>
            <ul className="space-y-3.5">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-teal-400 text-sm"></i>
                </div>
                <a
                  href="tel:+50766132697"
                  className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  +507 6613-2697
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-whatsapp-line text-green-400 text-sm"></i>
                </div>
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-green-400 hover:text-green-300 text-sm font-medium transition-colors cursor-pointer"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Escribir por WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-teal-400 text-sm"></i>
                </div>
                <span className="text-slate-400 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  El Dorado, al lado del Do It Center, Ciudad de Panamá
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-line text-teal-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-slate-400 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    Lun – Vie: 9:00 AM – 5:00 PM
                  </p>
                  <p className="text-slate-500 text-xs mt-1" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    Con cita previa
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-teal-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-slate-400 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    Pago en <strong className="text-slate-300">efectivo</strong> o <strong className="text-slate-300">Yappy</strong>
                  </p>
                  <p className="text-slate-500 text-xs mt-1" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    No se aceptan tarjetas
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-4 md:py-5 flex flex-col sm:flex-row items-center justify-between gap-2 md:gap-3">
          <p className="text-slate-500 text-xs text-center sm:text-left" style={{ fontFamily: "'Poppins', sans-serif" }}>
            © 2026 Clínica de Colposcopia Dr. Erick Tejada. Todos los derechos reservados.
          </p>
          <p className="text-slate-600 text-xs text-center" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Este sitio web fue diseñado por{" "}
            <a
              href="https://jcpublicidadpty.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-teal-400 hover:text-teal-300 transition-colors cursor-pointer"
            >
              JC Publicidad
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
